import React from "react";
import { set } from "dot-prop-immutable";
import { toolFormAttr, toolCollapseAttr, getLocale } from '@utils/util';
import { SimpleForm as Form, Collapse, Switch } from '@whalecloud/fdx';
import HeightSetting from '@whalecloud/page-builder-base-components/components/ElementSettings/HeightSetting';
import CommonItemSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/CommonItemSettings';

const { Panel } = Collapse;

const valueKey = 'data.formItemSettings';

const RichEditorSettings = (props: any) => {
  const messages = getLocale();

  const { updateElement, element } = props;
  const { data: { formItemSettings = {} } = {} } = element;
  const {
    readOnly,
  } = formItemSettings;

  const onFormChange = (obj: Object) => {
    Object.keys(obj).forEach((key: string) => {
      const propName = `${valueKey}.${key}`;
      const newElement = set(element, propName, obj[key]);

      updateElement({
        element: newElement,
      });
    });
  };
  return (
    <Collapse {...toolCollapseAttr} defaultActiveKey={['1']}>
      <Panel header={messages['PAGEBUIDER_SETTINGS']} key="1">
        <CommonItemSettings allowClearHide />
        <HeightSetting />
        <Form {...toolFormAttr} initialValues={{ readOnly }} onValuesChange={onFormChange}>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_READONLY']} name="readOnly" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Form>
      </Panel>
    </Collapse>
  );
};

export default RichEditorSettings;
